import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetUpliftIndexesQuery from '@/graphql/contracts/getUpliftIndexes.query.gql';
import UpdateUpliftIndexMutation from '@/graphql/contracts/updateUpliftIndex.mutation.gql';
import {
  UpdateUpliftIndex,
  UpdateUpliftIndexVariables
} from '@/graphql/contracts/_generated_/updateUpliftIndex.mutation';

export function useUpdateUpliftIndex(regionName?: string) {
  return useMutation<UpdateUpliftIndex, UpdateUpliftIndexVariables>(UpdateUpliftIndexMutation, {
    client: apolloClientContracts,
    refetchQueries: () => [{
      query: GetUpliftIndexesQuery,
      variables: {
        region: regionName,
        includeRates: true,
      },
    }],
  });
}
